import { BrandConfig } from './types/brand';
import { resolveBrandConfig } from './brands';

// Get the brand name from environment variable
const brandName = import.meta.env.VITE_BRAND || 'nw_club';
const brandConfigFromEnv = resolveBrandConfig(brandName);

// Create a promise that resolves with the brand config
export const brandConfigPromise = Promise.resolve(brandConfigFromEnv || {
  name: "Default Brand",
  logo: "/logo.svg",
  colors: {
    primary: {
      DEFAULT: '#174265',
      50: '#f0f7ff',
      100: '#e0f1ff',
      200: '#b9e3ff',
      300: '#7dcfff',
      400: '#3b8abf',
      500: '#174265',
      600: '#123854',
      700: '#0e2f47',
      800: '#0a253a',
      900: '#071c2d',
    },
    secondary: {
      DEFAULT: '#5ac1ee',
      50: '#f0f9ff',
      100: '#e0f7ff',
      200: '#b9efff',
      300: '#7de7ff',
      400: '#5ac1ee',
      500: '#5ac1ee',
      600: '#38a3d1',
      700: '#2b89b3',
      800: '#236f95',
      900: '#1d5a7a',
    }
  },
  supabaseUrl: '',
  supabaseKey: '',
  contactEmail: '',
  contactPhone: '',
  socialLinks: {
    facebook: '',
    twitter: '',
    instagram: '',
    youtube: '',
    bluesky: ''
  },
  mobilizeUrl: '',
  actBlueUrl: '',
  actBlueUrls: { membership: [], nonMembership: [] },
  description: '',
});

// Export the brand config (this will be undefined until the promise resolves)
export let brandConfig: BrandConfig;

// Initialize the brand config
brandConfigPromise.then(config => {
  brandConfig = config;
});
